// utils/argentineHolidays.ts
// Feriados Nacionales de Argentina 2025

export interface Holiday {
  date: string; // YYYY-MM-DD
  name: string;
  type: 'nacional' | 'puente';
}

export const ARGENTINE_HOLIDAYS_2025: Holiday[] = [
  // Enero
  { date: '2025-01-01', name: 'Año Nuevo', type: 'nacional' },
  
  // Febrero
  { date: '2025-02-24', name: 'Carnaval', type: 'nacional' },
  { date: '2025-02-25', name: 'Carnaval', type: 'nacional' },
  
  // Marzo
  { date: '2025-03-24', name: 'Día Nacional de la Memoria por la Verdad y la Justicia', type: 'nacional' },
  
  // Abril
  { date: '2025-04-02', name: 'Día del Veterano y de los Caídos en la Guerra de Malvinas', type: 'nacional' },
  { date: '2025-04-18', name: 'Viernes Santo', type: 'nacional' },
  
  // Mayo
  { date: '2025-05-01', name: 'Día del Trabajador', type: 'nacional' },
  { date: '2025-05-25', name: 'Día de la Revolución de Mayo', type: 'nacional' },
  
  // Junio
  { date: '2025-06-16', name: 'Paso a la Inmortalidad del General Güemes', type: 'nacional' },
  { date: '2025-06-20', name: 'Paso a la Inmortalidad del General Belgrano', type: 'nacional' },
  
  // Julio
  { date: '2025-07-09', name: 'Día de la Independencia', type: 'nacional' },
  
  // Agosto
  { date: '2025-08-17', name: 'Paso a la Inmortalidad del General San Martín', type: 'nacional' },
  
  // Octubre
  { date: '2025-10-12', name: 'Día del Respeto a la Diversidad Cultural', type: 'nacional' },
  
  // Noviembre
  { date: '2025-11-24', name: 'Día de la Soberanía Nacional', type: 'nacional' },
  
  // Diciembre
  { date: '2025-12-08', name: 'Día de la Inmaculada Concepción de María', type: 'nacional' },
  { date: '2025-12-25', name: 'Navidad', type: 'nacional' }
];

/**
 * Verifica si una fecha es feriado nacional
 */
export const isHoliday = (date: Date): Holiday | null => {
  const dateStr = date.toISOString().split('T')[0];
  return ARGENTINE_HOLIDAYS_2025.find(h => h.date === dateStr) || null;
};

/**
 * Obtiene el nombre del feriado si existe
 */
export const getHolidayName = (date: Date): string | null => {
  const holiday = isHoliday(date);
  return holiday ? holiday.name : null;
};

/**
 * Obtiene todos los feriados de un mes específico
 */
export const getHolidaysForMonth = (year: number, month: number): Holiday[] => {
  return ARGENTINE_HOLIDAYS_2025.filter(holiday => {
    const [y, m] = holiday.date.split('-').map(Number);
    return y === year && m === month + 1;
  });
};